<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Bulk Run</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>

<div class="modal-body" hsDraggable="modal-dialog">
  <nf-form-control>
    <label for="dateRange">Recon Date Range</label>
    <nf-daterange
      id="dateRange"
      name="dateRange"
      [ngModel]="dateRange"
      (ngModelChange)="applyDateRange($event)"
      [beginDateRequired]="true"
      [endDateRequired]="true"
    >
    </nf-daterange>
    <br />
    <nf-form-control label="Trigger Runs for" compact class="stacked">
      <nf-radio-group [formControl]="runFrequency">
        <nf-radio-button
          label="Every Day"
          value="EVERY_DAY"
          [inline]="true"
        ></nf-radio-button>
        <nf-radio-button
          [label]="NDays"
          value="EVERY_N_DAYS"
          [inline]="true"
        ></nf-radio-button>
        <nf-radio-button
          [label]="TDays"
          value="EVERY_NTH_DAY_OF_THE_MONTH"
          [inline]="true"
        ></nf-radio-button>
      </nf-radio-group>
    </nf-form-control>
    <br />
    <label for="filterAccounts"
      >Filtered Accounts ({{
        filteredAccountIds ? filteredAccountIds?.split(',')?.length : 0
      }})</label
    >
    <input
      id="filterAccounts"
      type="text"
      class="form-control"
      [(ngModel)]="filteredAccountIds"
    />
  </nf-form-control>
  <div class="d-flex flex-row spaced">
    <nf-form-control label="Run Type" compact>
      <nf-radio-group class="d-flex flex-column" [formControl]="runType">
        <nf-radio-button
          label="Run with ETL(s)"
          value="CUSTODY_ETL"
          [inline]="true"
          [ngClass]="{ disabled: disableRunType }"
        ></nf-radio-button>
        <nf-radio-button
          label="Run without ETL(s)"
          value="CUSTODY"
          [inline]="true"
          [ngClass]="{ disabled: disableRunType }"
        ></nf-radio-button>
        <nf-radio-button
          label="Run with Trading ETL(s)"
          value="TRADING"
          [inline]="true"
          [ngClass]="{ disabled: disableRunType }"
        ></nf-radio-button>
      </nf-radio-group>
    </nf-form-control>
    <div class="d-flex flex-column">
      <label class="stacked">Run Settings</label>
      <nf-checkbox
        [formControl]="rePredictDistributions"
        label="Repredict Distributions"
        [ngClass]="{ disabled: disableRunType }"
      >
      </nf-checkbox>
      <nf-checkbox [formControl]="forceReconTS" label="Force Recon Timestamp">
      </nf-checkbox>
    </div>
  </div>
</div>

<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()">Cancel</button>
    <button nf-button="save" (click)="onSave()">Submit</button>
  </div>
</div>
<ng-template #NDays>
  <label class="preText">Every</label>
  <nf-form-control class="midInput" compact for="nDay">
    <input type="text" id="nDay" class="form-control" [formControl]="nDay" />
  </nf-form-control>
  <label class="postText">Day(s)</label>
</ng-template>
<ng-template #TDays>
  <label class="preText">Every</label>
  <nf-form-control class="midSelect">
    <ng-select
      id="repeatingDay"
      name="periodLength"
      [items]="Days"
      [clearable]="false"
      [searchable]="true"
      [formControl]="repeatingDay"
    >
      <ng-template ng-option-tmp let-item="item">
        <div [ngbTooltip]="item" container="body" class="ellipsis">
          {{ item }}
        </div>
      </ng-template>
    </ng-select>
  </nf-form-control>
  <label class="postText">of the month</label>
</ng-template>
